import * as _ from 'lodash';
import Toaster from 'src/components/Toaster/Toaster';
import { IShowToasterParams } from 'src/models';

export default {
    toasterComponent: null,
    reportToasterIds: [], 

    dispose() {
        if (this.toasterComponent) {
            this.toasterComponent.dispose();
        }
        this.toasterComponent = null;
    },

    show(params: IShowToasterParams): number {
        if (!this.toasterComponent) {
            this.toasterComponent = new Toaster({
                source: '<x-toaster></x-toaster>'
            });
            this.toasterComponent.attach(document.body);
        }
        return this.toasterComponent.show(params);
    },

    remove(id: number) {
        this.toasterComponent.remove(id);
        _.remove(this.reportToasterIds, (toasterId)=> toasterId === id);
    },

    getReportToasterIds() {
        return this.reportToasterIds;
    },

    setReportToasterIds(ids: string[]) {
        this.reportToasterIds = ids;
    }
};
